import { call, put, select } from 'redux-saga/effects';

import {
  setAvailableChapters,
  setAvailableChaptersLoading,
  setBuildChapterStudyPlanLoading,
  setChapterStudyPlan,
  setSaveChaptersLoading,
} from '../actions/personalizedStudyActions';
import { getSwitchPfeSkt } from '../components/AccountSettings/AccountSettingsSelectors';
import {
  buildChapterStudyPlanService,
  getReferenceDataService,
  loadChapterStudyPlanService,
  saveSelectedChaptersService,
} from '../services/personalizedStudyService';

export function* getAvailableChaptersSaga(action) {
  try {
    yield put(setAvailableChapters(undefined));
    yield put(setAvailableChaptersLoading(true));
    const response = yield call(getReferenceDataService, action.rate);
    yield put(setAvailableChapters(response.globalCounters));
    yield put(setAvailableChaptersLoading(false));
  } catch (e) {
    yield put(setAvailableChaptersLoading(false));
  }
}

export function* saveSelectedChaptersSaga(action) {
  try {
    yield put(setSaveChaptersLoading(true));
    yield call(saveSelectedChaptersService, action.chapters);

    // Re-fetch reference data using the active PFE/SKT rate, not always SKT
    const pfeSktId = yield select(getSwitchPfeSkt);
    if (pfeSktId) {
      const updated = yield call(getReferenceDataService, pfeSktId);
      yield put(setAvailableChapters(updated.globalCounters));
    }

    yield put(setSaveChaptersLoading(false));
  } catch (e) {
    yield put(setSaveChaptersLoading(false));
  }
}

export function* buildChapterStudyPlanSaga(action) {
  try {
    yield put(setBuildChapterStudyPlanLoading(true));
    yield call(buildChapterStudyPlanService, action.startDate, action.examDate);
    const plan = yield call(loadChapterStudyPlanService);
    yield put(setChapterStudyPlan(plan));
    yield put(setBuildChapterStudyPlanLoading(false));
  } catch (e) {
    yield put(setBuildChapterStudyPlanLoading(false));
  }
}

export function* loadChapterStudyPlanSaga() {
  try {
    yield put(setChapterStudyPlan(undefined));
    const plan = yield call(loadChapterStudyPlanService);
    yield put(setChapterStudyPlan(plan));
  } catch (e) {}
}
